<template>
  <v-row class="mt-4 px-4 pt-4 bt-1 bc-extra-light-gray">
    <v-col
      cols="12"
      md="6"
    >
      <v-btn
        v-if="onBack"
        @click="processBack"
        :block="$vuetify.display.smAndDown"
        :loading="processing"
        color="primary"
        variant="outlined"
        data-skip-event
      >
        {{ $bct(backText) }}
      </v-btn>
    </v-col>
    <v-col
      v-if="onNext"
      class="d-flex justify-end"
      cols="12"
      md="6"
    >
      <v-btn
        @click="processNext"
        :block="$vuetify.display.smAndDown"
        :loading="processing"
        color="primary"
        data-skip-event
      >
        {{ $bct(nextText) }}
      </v-btn>
    </v-col>
    <slot name="next" />
  </v-row>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import useSegment from '@/shared/composables/analytics/useSegment';

const $bct = inject('translator');
const route = useRoute();
const store = useStore();
const segment = useSegment();

const props = defineProps({
  backText: {
    type: String,
    default: 'Back',
  },
  nextText: {
    type: String,
    default: 'Next',
  },
  processing: {
    type: Boolean,
    default: false,
  },
  onBack: {
    type: Function,
    default: null,
  },
  onNext: {
    type: Function,
    default: null,
  },
  // Track more analytics data
  backType: {
    type: String,
    default: 'Navigation',
  },
  nextType: {
    type: String,
    default: 'Navigation',
  },
  componentName: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['back', 'next']);

function trackButtonClick(buttonText, buttonType) {
  segment.track('Button Clicked', {
    text: buttonText,
    portal: store.state.config.title,
    current_page_component: props.componentName || route.name,
    current_route: route.path,
    type: buttonType,
    url: window.location.href,
  });
}

function processBack(event) {
  event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  trackButtonClick(props.backText, props.backType);
  emit('back');
}

function processNext(event) {
  event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  trackButtonClick(props.nextText, props.nextType);
  emit('next');
}
</script>
